// @TODO Need to agree on a standard for this.

/**
 * Override to prevent upading of LESSON_STATUS once course is completed.
 */
LMSAdaptor.prototype.setLessonStatus = function( e )
{
	var currentStatus = this.app.tracking.getCmiData("LESSON_STATUS");
	if(currentStatus === "completed") return false;

	var status = e.status;

	if( !status ) return;

	// More specific events for specific block statuses
	switch(status) {
		case Status.PASSED:
			this.app.tracking.setCmiData("LESSON_STATUS", "passed" );
			break;
		case Status.COMPLETED:
			this.app.tracking.setCmiData("LESSON_STATUS", "completed" );
			break;
		case Status.FAILED:
			this.app.tracking.setCmiData("LESSON_STATUS", "failed" );
			break;
		case Status.STARTED:
			this.app.tracking.setCmiData("LESSON_STATUS", "incomplete" );
			break;
		default:
			this.app.tracking.setCmiData("LESSON_STATUS", "incomplete" );
	}

};
